/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" collapse-transition router :default-active="$route.path" class="el-menu-vertical-demo"
           background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      智能AI诊断系统
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title" v-if="!menu.requireSuper || isSuper">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid" v-if="!chmenu.requireSuper || isSuper">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
  import {menu} from '../api/userMG'
  import {getStore} from "../utils/util";

  export default {
    name: 'leftnav',
    data() {
      return {
        collapsed: false,
        allmenu: [],
        isSuper:parseInt(getStore('isSuper'))
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      // 获取图形验证码
      let res = {
        success: true,
        data: [
          {
            menuid: 10,
            icon: 'li-icon-shujujiankong',
            menuname: '首页',
            hasThird: null,
            url: null,
            requireSuper:false,
            menus: [
              {
                menuid: 101,
                icon: 'li-icon-xiangmuguanli',
                menuname: '欢迎页',
                hasThird: null,
                requireSuper:false,
                url: 'system/home'
              }
            ]
          },
          {
            menuid: 11,
            icon: 'li-icon-xiangmuguanli',
            menuname: '检测与诊断',
            hasThird: null,
            requireSuper:false,
            url: null,
            menus: [
              {
                menuid: 111,
                icon: 'icon-cat-skuQuery',
                menuname: '体质',
                hasThird: 'N',
                requireSuper:false,
                url: 'physique/list',
                menus: null
              },
              {
                menuid: 113,
                icon: 'icon-cat-skuQuery',
                menuname: '舌象',
                hasThird: 'N',
                url: 'tongue/list',
                requireSuper:false,
                menus: null
              },
              {
                menuid: 112,
                icon: 'icon-cat-skuQuery',
                menuname: '经络',
                hasThird: 'N',
                url: 'meridian/list',
                requireSuper:false,
                menus: null
              },
              {
                menuid: 114,
                icon: 'icon-cat-skuQuery',
                menuname: '综合报告',
                hasThird: 'N',
                url: 'combination/list',
                requireSuper:false,
                menus: null
              }
            ]
          },
          {
            menuid: 14,
            icon: 'li-icon-jichuguanli',
            menuname: '用户管理',
            hasThird: null,
            requireSuper:false,
            url: null,
            menus: [
              {
                menuid: 151,
                icon: 'li-icon-jichuguanli',
                menuname: '用户管理',
                hasThird: 'N',
                url: 'user/list',
                requireSuper:false,
                menus: null
              }
            ]
          },
          {
            menuid: 16,
            icon: 'li-icon-jichuguanli',
            menuname: '设置',
            hasThird: null,
            requireSuper:false,
            url: null,
            menus: [
              {
                menuid: 161,
                icon: 'icon-cat-skuQuery',
                menuname: '应用管理',
                hasThird: 'N',
                url: 'app/list',
                requireSuper:true,
                menus: null
              }
            ]
          }
        ],
        msg: 'success'
      }
      this.allmenu = res.data
      this.$root.Bus.$on('toggle', value => {
        this.collapsed = !value
      })
    }
  }
</script>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    text-align: left;
  }

  .el-menu-item-group__title {
    padding: 0px;
  }

  .el-menu-bg {
    background-color: #1f2d3d !important;
  }

  .el-menu {
    border: none;
  }

  .logobox {
    color: #fff;
    font-size: 24px;
    text-align: center;
    padding: 14px 0px;
  }

  .logoimg {
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue